import { Component, Inject, OnInit, Input, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import * as d3 from 'd3';
import { TimestampTexts } from '../models/timestamp-texts';
import { TimespanService } from '../services/timespan/timespan.service';

/**
 * Legenda contínua. Exibe valor inferior e superior, e uma barra de gradiente.
 */
@Component({
  selector: 'app-legend',
  templateUrl: './legend.component.html',
  styleUrls: ['./legend.component.css']
})
export class LegendComponent implements OnInit, AfterViewInit {

  barWidth: number = 20;
  barHeight: number = 50;
  //identifier: any = "#heatmap-legend";
  @Input() identifier: string;

  svg: any;
  private titleObj: any;
  private timestampObj: any;
  upperTextObj: any;
  lowerTextObj: any;
  titleLines: string[] = [];
  stops: d3.Selection<d3.BaseType, {
      rgb: any;
      percent: number;
  }, d3.BaseType, unknown>;

  visibilityCSS = 'enabled';

  
  constructor(){    
  }

  ngOnInit() {
    this.createSvg();
    this.updateColor(d3.interpolateYlOrRd);
    this.insertText(["-"], "-", "-");
  }

  ngAfterViewInit(): void {}

  /**
   * 
   * @param titleLines 
   * @param values 
   * @param valueType 
   * @param colorScale 
   */
  public update(
    titleLines: string[], 
    values: number[], 
    valueType: string,
    colorScale: (t: number) => string = d3.interpolateBlues) {

    this.updateColor(colorScale);

    let maxVal = values[values.length - 1];
    let minVal = values[0];
  
    let maxValText = this.formatValue(maxVal, valueType);
    let minValText = this.formatValue(minVal, valueType);
  
    this.insertText(titleLines, maxValText, minValText);
  }

  /**
   * Formata os valores inferior e superior a serem exibidos na legenda.
   * @param value valor (inferior ou superior) a ser exibido.
   * @param valueType indica como o valor deve ser formatado.
   * @returns 
   */
  private formatValue(value: number, valueType: string) {

    if (valueType == '%') {
      return `${value.toFixed(2)} ${valueType}`;
    }
    if (valueType == 'dhm') {
      return TimespanService.secondsToFormattedText(value);
    }
    if (valueType == 'int') {
      return value.toString();
    }
    return value.toFixed(2);
  }

  /**
   * Cria o svg da barra da legenda, que será posteriormente colorida.
   */
  public createSvg() {

    this.svg = d3.select(this.identifier).append("svg")
                .attr("width", this.barWidth +130)
                .attr("height", this.barHeight+0);

    this.svg.append("defs").append("linearGradient")
                                .attr("id", "grad-"+this.identifier.replace('#','').replace('.',''))
                                .attr("x1", "0%")
                                .attr("x2", "0%")
                                .attr("y1", "100%")
                                .attr("y2", "0%");

    this.svg.append("rect")
                .attr("x", "0")
                .attr("y", "0")
                .attr("width", this.barWidth)
                .attr("height", this.barHeight)
                .attr("fill", "url(#"+"grad-"+this.identifier.replace('#','').replace('.','')+')');

  }

  /**
   * Colore a barra da legenda em gradiente.
   * @param interpolateFunc função de interpolação para colorir a barra.
   */
  public insertColor(interpolateFunc: Function) {

    let colorData = [];
    let numberHues = 100;
    let delta = 1/numberHues;

    for(let i=0; i<numberHues; i++){
        colorData.push({"rgb": interpolateFunc(i*delta), "percent": i*delta});
    }

    this.stops = d3.select('#'+"grad-"+this.identifier.replace('#','').replace('.','')).selectAll('stop').data(colorData);


    this.stops.enter().append('stop').attr('offset', function(d){
        return d.percent;    
    }).attr('stop-color', function(d){
        return d.rgb;
    }).attr('stop-opacity', 1);

  } 

  /**
   * Insere os textos inferior e superior da legenda.
   * @param titleLines linhas do título da legenda.
   * @param uptext texto superior.
   * @param lowertext texto inferior.
   */
  public insertText(titleLines: string[], uptext: string, lowertext: string) {
    this.titleLines = titleLines;
    this.upperTextObj = this.svg.append("text")
                            .attr("text-anchor", "left")
                            .attr("x", this.barWidth + 4)
                            .attr("y", 12)
                            .text(uptext)
                            // .style("font-size", "15px")
                            .style("font-family", "Arial, sans-serif")
                            .style("font-weight", "bold")
                            .style("fill", "black")
                            

    this.lowerTextObj = this.svg.append("text")
                            .attr("text-anchor", "left")
                            .attr("x", this.barWidth + 4)
                            .attr("y", this.barHeight)
                            .text(lowertext)
                            // .style("font-size", "15px")
                            .style("font-family", "Arial, sans-serif")
                            .style("font-weight", "bold")
                            .style("fill", "black");

  }

  /**
   * Atualiza os textos inferior e superior da legenda.
   * @param upperText texto superior.
   * @param lowerText texto inferior.
   */
  updateTexts(upperText: string, lowerText: string) {
    this.upperTextObj.text(upperText);
    this.lowerTextObj.text(lowerText);
  }

  /**
   * Atualiza a cor da barra da legenda.
   * @param interpolateFunc função usada para colorir a barra.
   */
  public updateColor(interpolateFunc: Function){
    this.destroySVG();
    this.createSvg();

    let colorData = [];
    let numberHues = 100;
    let delta = 1/numberHues;

    for(let i=0; i<numberHues; i++){
        colorData.push({"rgb": interpolateFunc(i*delta), "percent": i*delta});
    }

    let stops = d3.select('#'+"grad-"+this.identifier.replace('#','').replace('.','')).selectAll('stop').data(colorData);

    stops.enter().append('stop').attr('offset', function(d){
      return d.percent;    
    }).attr('stop-color', function(d){
      return d.rgb;
    }).attr('stop-opacity', 1);
    

  }

  /**
   * Destrói o svg da barra da legenda.
   */
  public destroySVG(){
    this.svg.remove();
  }

  /**
   * Obtém o id html da legenda.
   * @returns 
   */
  public getHTMLId() {
    return this.identifier.replace('#', '');
  }
} 



